import PropTypes from "prop-types";

const PricingItem = ({ data, index }) => {
    const num = String(index + 1).padStart(2, "0");
    return (
        <div className={data.classOption}>
            <div className="pricing-title">
                <span className="pricing-index">{num}</span>
                <h5>{data.title}</h5>
            </div>
            <div className="pricing-content">
                <p className="desc">{data.excerpt}</p>
                <ul className="pricing-list">
                    {data.pricingList &&
                        data.pricingList.map((single, key) => {
                            return <li key={key}>{single}</li>;
                        })}
                </ul>
            </div>
        </div>
    );
};

PricingItem.propTypes = {
    data: PropTypes.object,
    index: PropTypes.number,
};

export default PricingItem;
